import {
    getAllData,
    uploadData,
    destroyData,
    getDataWithParams

} from '@/store/api/method-mbkm'

const itemInit = {
    id: null,
    name: null,
    created_by: null,
    created_at: null,
    updated_by: null,
    updated_at: null
}

const requestInit = {
    page: 1,
    show: 10,
    sortBy: "created_at",
    sorting: "ASC",
    search: null,
    filter: null
}
const initialState = () => ({
    data: {},
    allSkalaStudiIndependen: [],
    msg: "Jaringan Bermasalah",
    status: 0,
    request: {...requestInit},
    response: {},
    item: {...itemInit}
})

const state = initialState

const getters = {
    getData: state => state.data || {},
    getRequest: state => state.request,
    getMsg: state => state.msg,
    getStatus: state => state.status,
    getItem: state => state.item,
    getResponse: state => state.response,
    getAutoComplete: state => state.allSkalaStudiIndependen

}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = '0'
    },
    SET_MSG_FAILED(state, err) {
        if (err.status == 400) {
            state.msg = err.data.response
            state.status = err.data.status
        } else {
            state.msg = 'Jaringan Bermasalah'
            state.status = '0'
        }
    },
    SET_RESPONSE(state, response) {
        state.response = {
            msg: response.msg,
            status: response.status
        }
    },
    SET_DATA(state, value) {
        state.data = value
    },
    SET_REQUEST(state, value) {
        state.request = value
    },
    SET_ITEM(state, value) {
        state.item = value
    },
    resetState(state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
    SET_SKALA(state, response){
        state.response = {
            msg: response.msg,
            status: response.status
        }
        state.allSkalaStudiIndependen = response.data
    },
}


const actions = {
    setRequest({commit}, value){
        commit('SET_REQUEST',value)
    },
    setItem({commit}, value){
        commit('SET_ITEM',{...value})
    },
    resetItem({commit}){
        commit('SET_ITEM', {...itemInit})
    },
    resetRequest({commit}){
        commit('SET_REQUEST', {...requestInit})
    },
    async getAllData({commit, state}) {
        try {
            const response = await getDataWithParams('/studiindependent-scale', state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    async getAllSkalaStudiIndependent({commit }) //Get Skala Studi Independen Tanpa Pagination
    {
        try {
            var response = await getAllData('/studiindependent-getscale');
            commit('SET_SKALA', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },

    async store({commit }, data) {
        try {
            const response = await uploadData('/studiindependent-scale', data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async update({commit }, {id, data}) {
        try {
            const url = `/studiindependent-scale/${id}`
            const response = await uploadData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    async destroy({commit }, id) {
        try {
            const url = `/studiindependent-scale/${id}`
            const response = await destroyData(url)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    }
}




export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}